<template>
  <iColumn>
    <iRow wrap="nowrap">
      <iSpace />
      <iColumn>
        <iRow vertical-align="middle" wrap="nowrap" gap="extraSmall">
          <iIcon
            v-if="hasValidPasswordLength"
            name="check-circle"
            :style-overrides="checkIconStyleOverrides"
          />
          <iIcon v-else name="cancel" variant="subtle" />
          <iText>
            between 6 and 128 characters
          </iText>
        </iRow>
        <iRow vertical-align="middle" wrap="nowrap" gap="extraSmall">
          <iIcon
            v-if="hasSpecialCharacter"
            name="check-circle"
            :style-overrides="checkIconStyleOverrides"
          />
          <iIcon v-else name="cancel" variant="subtle" />
          <iText>
            at least one special character
          </iText>
        </iRow>
        <iRow vertical-align="middle" wrap="nowrap" gap="extraSmall">
          <iIcon
            v-if="hasUpperAndLowerCase"
            name="check-circle"
            :style-overrides="checkIconStyleOverrides"
          />
          <iIcon v-else name="cancel" variant="subtle" />
          <iText>
            at least one uppercase & one lowercase letter
          </iText>
        </iRow>
      </iColumn>
    </iRow>
  </iColumn>
</template>

<script>

export default {
  name: "PasswordComplexity",
  props: {
    password: {
      type: String,
      required: true,
    },
  },
  emits: ["update:password", "update:passwordValidity"],
  computed: {
    checkIconStyleOverrides() {
      return { primaryVariantColor: "primary.serious" };
    },
    hasValidPasswordLength() {
      if (!this.password) {
        return false;
      }
      return !(this.password.length < 6 || this.password.length > 128);
    },
    hasSpecialCharacter() {
      if (!this.password) {
        return false;
      }
      return /[!@#$%^&*]/.test(this.password);
    },
    hasUpperAndLowerCase() {
      return !!(this.password && /[A-Z]/.test(this.password) && /[a-z]/.test(this.password));
    },
  },
  watch: {
    password() {
      this.updatePassword();
    },
  },
  methods: {
    updatePassword() {
      this.$emit("update:password", this.hasUpperAndLowerCase && this.hasValidPasswordLength && this.hasSpecialCharacter);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
